<div class="ui-g-12 ui-md-12">
  <div *ngIf="!mostrar">
      <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

  </div>
  <div *ngIf="mostrar">

    <div class="">
        <app-simple-table 
            [cols]="cols" 
            [listarTodos]="listarTodos" 
            [items]="usuario" 
            [database]="database"
            [showInfo]="showInfo" 
            [mostrarInformes]="mostrarInformes" 
            [showDuplicate]="showDuplicate"
            (listarCamposEmmit)="listarCampos()" 
            (changeValueRevisionEmmit)="changeValueRevision($event)"
            (changeValueEmmit)="changeValue($event)" 
            (iniciarEmmit)="iniciar()" 
            (deleteEmmit)="delete($event)" 
            (consultarInformes)="consultar($event)" 
            (duplicateEmmit)="duplicate($event)"></app-simple-table>
    </div>
  </div>
  <p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-dialog header="usuario" [(visible)]="display" [contentStyle]="{'background-color':'white','max-height':'400px','min-width':'500px'}">
         
</p-dialog>

<p-dialog header="Usuario" [(visible)]="displayUser">
    El usuario Admin no puede ser borrado
</p-dialog>

<p-toast ></p-toast>